// IRISReferenceLists.jsx
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { referenceSections } from 'data/reports/referenceSections'; // Adjust path as needed

const IRISReferenceLists = () => {
  const navigate = useNavigate();

  const [openSection, setOpenSection] = useState(null);

  const toggleSection = (id) => {
    setOpenSection(openSection === id ? null : id);
  };

  // ── Styles ────────────────────────────────────────────────────────────────
  const backButtonStyle = {
    display: 'inline-flex',
    alignItems: 'center',
    gap: '8px',
    padding: '10px 20px',
    backgroundColor: 'transparent',
    border: '1px solid #0d47a1',
    borderRadius: '6px',
    color: '#0d47a1',
    fontWeight: '500',
    fontSize: '1rem',
    cursor: 'pointer',
    transition: 'all 0.2s ease',
    marginBottom: '32px',
  };

  const containerStyle = {
    maxWidth: '1200px',
    margin: '0 auto',
    padding: '32px 24px',
    fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
    backgroundColor: '#ffffff',
    color: '#1a1a1a',
    lineHeight: '1.6',
  };

  const titleStyle = {
    margin: '0 0 8px 0',
    fontSize: '2rem',
    fontWeight: '700',
    color: '#0d47a1',
  };

  const subtitleStyle = {
    color: '#555',
    fontSize: '1.1rem',
  };

  const accordionItemStyle = {
    marginBottom: '16px',
    border: '1px solid #e0e0e0',
    borderRadius: '8px',
    overflow: 'hidden',
    boxShadow: '0 2px 8px rgba(0,0,0,0.05)',
  };

  const headerRowStyle = {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: '16px 20px',
    backgroundColor: '#f8f9fa',
    cursor: 'pointer',
    userSelect: 'none',
    transition: 'background-color 0.2s ease',
  };

  const headerTextStyle = {
    fontSize: '1.1rem',
    fontWeight: '600',
    color: '#0d47a1',
    margin: 0,
  };

  const iconStyle = {
    fontSize: '1.4rem',
    fontWeight: 'bold',
    color: '#0d47a1',
    transition: 'transform 0.3s ease',
  };

  const contentStyleBase = {
    backgroundColor: '#fff',
    transition: 'all 0.4s ease',
  };

  // ── Render ────────────────────────────────────────────────────────────────
  return (
    <div style={containerStyle}>
      {/* Back Button */}
      <button
        onClick={() => navigate('/reporting/iris/iris-giin-compliance-matrix/iris-system-kpi-proj-entities',
            { replace: true }
        )}
        style={backButtonStyle}
        onMouseEnter={(e) => (e.currentTarget.style.backgroundColor = '#e3f2fd')}
        onMouseLeave={(e) => (e.currentTarget.style.backgroundColor = 'transparent')}
      >
        ← Back to IRIS 5.3a Overview
      </button>

      <header style={{ marginBottom: '32px' }}>
        <h1 style={titleStyle}>IRIS 5.3a Reference Lists</h1>
        <p style={subtitleStyle}>Expandable reference options used in IRIS+ 5.3a</p>
      </header>

      <div>
        {referenceSections.map((section) => {
          const isOpen = openSection === section.id;

          return (
            <div key={section.id} style={accordionItemStyle}>
              {/* Header - always visible */}
              <div
                style={headerRowStyle}
                onClick={() => toggleSection(section.id)}
              >
                <h3 style={headerTextStyle}>{section.title}</h3>
                <span
                  style={{
                    ...iconStyle,
                    transform: isOpen ? 'rotate(45deg)' : 'rotate(0deg)',
                  }}
                >
                  {isOpen ? '−' : '+'}
                </span>
              </div>

              {/* Content - scrollable when open */}
              <div
                style={{
                  ...contentStyleBase,
                  maxHeight: isOpen ? '70vh' : '0',            // ← adjustable: 60vh, 80vh, 500px, etc.
                  overflowY: isOpen ? 'auto' : 'hidden',       // ← SCROLL ENABLED
                  padding: isOpen ? '20px' : '0 20px',
                  display: isOpen ? 'block' : 'none',          // ← fully hide when closed
                }}
              >
                {section.content}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default IRISReferenceLists;